const profilesFields = {
  form: {
    user: {
      user_id: '',
      lastname: '',
      name: '',
      patronymic: '',
      birth_date: '',
      birth_place: '',
      sex_id: '',
      citizenship_id: '',
      email: '',
      photo: '',
      identity_document_id: '',
      identity_document_series: '',
      identity_document_number: '',
      driver_license_id: '',
    },
    company: {
      subject_id: '',
      name_legal: '',
      address_legal: '',
      registraton_date: '',
      // inn: '',
      kpp: '',
      ogrn: '',
      eio: '',
      address_fact: '',
      ogrnip: '',
      // phone: '',
      // email: '',
      site: '',
      nds: '',
      // lastname: '',
      // name: '',
      // patronymic: '',
      // birth_date: '',
      // birth_place: '',
      // passport_series: '',
      // passport_number: '',
      company_type_id: '',
      // phone_code: '',
      // picture: '',
      tariff_type_id: '',
      tariff_fee_period_id: '',
      tariff_purchase_date: '',
      tariff_end_date: '',
      teleportos_account_id: '',
      cashier_account_id: '',
      passport_data: '',
      passport_authority: '',
    },
  },
  licenseePhysicalFields: {
    company_type_id: 2, // Перевозчик
    role_id: 2, // Администратор
    subject_id: 5, // Физическое лицо
    name: '',
    lastname: '',
    patronymic: '',
    birth_date: '',
    birth_place: '',
    name_legal: '',
    placeholder: '',
    address_legal: '',
    registraton_date: '',
    ogrnip: '',
    inn: '',
    kpp: '',
    // passport_data: '',
    // passport_authority: '',
  },
  licenseeIndividualFields: {
    company_type_id: 2, // Перевозчик
    role_id: 2, // Администратор
    subject_id: 6, // ИП
    name: '',
    lastname: '',
    patronymic: '',
    name_legal: '',
    placeholder: '',
    address_legal: '',
    inn: '',
    registraton_date: '',
    ogrnip: '',
    nds: 0,
    // passport_data: '',
    // passport_authority: '',
  },
  licenseeLegalEntityFields: {
    company_type_id: 2, // Перевозчик
    role_id: 2, // Администратор
    subject_id: 4, // Юридическое лицо
    // name: '',
    // lastname: '',
    // patronymic: '',
    name_legal: '',
    placeholder: '',
    address_legal: '',
    inn: '',
    // birth_date: '',
    kpp: '',
    ogrn: '',
    nds: 0,
    address_fact: '',
    // passport_data: '',
    // passport_authority: '',
  },
  commonFields: {
    photo: '',
    email_representative: '',
    email: '',
    site: '',
  },
  administratorFields: {
    lastname: '',
    name: '',
    patronymic: '',
    birth_date: '',
    email: '',
  },
};
export const fieldsFabric = type => {
  let fields = Object.assign({}, profilesFields);
  for (let key in profilesFields) {
    if (key === type) {
      fields = profilesFields[key];
    }
  }
  return fields;
};
export const formFieldsFabric = type => {
  let fields = Object.assign({}, profilesFields);
  for (let key in profilesFields) {
    if (profilesFields[key].subject_id === type) {
      fields = profilesFields[key];
    }
  }
  Object.assign(
    fields,
    profilesFields.commonFields,
    profilesFields.administratorFields
  );
  return fields;
};
